export const SHOPIFY_SIGNUP_QUERY_PARAMS = {
  TEMPORARY_ID: 'tempId',
  SHOP: 'shop',
  APP: 'shopifyApp',
  INTEGRATION: 'integration',
};

export const GOOGLE_AUTH_QUERY_PARAMS = {
  USER_ID: 'userId',
  AUTH: 'auth',
};
